
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/scr",
      function () {
        return require("private-next-pages/scr/index.js");
      }
    ]);
  